import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';

import { useSetTitle } from '@/stores/title-context';

function BookingsLayout() {
	const { t } = useLingui();
	useSetTitle(t`Bookings`);

	return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/_app/bookings')({
	component: BookingsLayout,
});
